import { Injectable } from '@angular/core';
import { Route, Router, CanLoad} from '@angular/router';
import { PermissionService } from '@shared/service/permission.service';
import { Observable } from 'rxjs/Observable';
import {Utilities} from '@shared/utilities/utilities.model';
import {ROOT_NOT_FOUND_PAGE} from './app-routing-roots';

export const DATA_KEY_MODULE = 'module';
export const DATA_KEY_PROFILES = 'profiles';
@Injectable()
export class CrossPermissionGuard implements CanLoad {
	constructor(private permissionService: PermissionService, private router: Router) {
	}

	canLoad(route: Route): Observable<boolean> {
		return new Observable<boolean>(observer => {
			const profiles = Utilities.getValueFromRoute(route, DATA_KEY_PROFILES) as string[];
			if (!Utilities.isVoid(profiles)) {
				this.permissionService.getUserV3Permission()
					.subscribe(
						userPermissions => {
							const hasProfile = userPermissions.hasProfile(profiles) ;
							if (!hasProfile) {
								this.router.navigate([ROOT_NOT_FOUND_PAGE]);
							}
							observer.next(hasProfile);
							observer.complete();
						}, error => {
							this.router.navigate([ROOT_NOT_FOUND_PAGE]);
							observer.next(false);
							observer.complete();
						});
			} else {
				observer.next(true);
				observer.complete();
			}
		});
	}
}
